/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   Butter Bar Container
 */

import { cn } from '@zcode-ui/shadz-ui'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { default as ButterBar } from './ButterBar'

class ButterBarContainer extends React.Component {
  static propTypes = {
    butterStack: PropTypes.array.isRequired,
  }

  shouldComponentUpdate(nextProps) {
    const { butterStack } = nextProps
    const prevButterStack = this.props.butterStack

    const sameRef = butterStack && prevButterStack && butterStack.length === prevButterStack.length
    return sameRef
      ? !butterStack.every((butter, idx) => butter.bbId === prevButterStack[idx].bbId)
      : true
  }

  render() {
    const butterStack = this.props.butterStack
    if (!butterStack || !butterStack.length) {
      return null
    }

    const butterBars = butterStack
      .map((butterBar, index) => {
        if (butterBar && butterBar.visible) {
          return (
            <ButterBar
              butterBar={butterBar}
              first={index === 0}
              key={butterBar.bbId.toString()}
              last={index === butterStack.length - 1}
            />
          )
        }
        return null
      })
      .filter((v) => v)

    return (
      <div
        className={cn(
          'fixed',
          'top-0',
          'desktop:top-[17px]',
          'right-0',
          'left-0',
          'z-[9900]',
          'text-center',
          'pointer-events-none'
        )}
        role="alert"
      >
        {butterBars}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  butterStack: state.butterBar.stack,
})

export default connect(mapStateToProps)(ButterBarContainer)
